"use client";

import { c as _c } from "react/compiler-runtime";
import { Menu } from "@base-ui/react/menu";
import { IconCheck, IconChevronRight } from "@tabler/icons-react";
import { cn } from "../utils";
function DropdownMenu(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <Menu.Root data-slot="dropdown-menu" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuPortal(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <Menu.Portal data-slot="dropdown-menu-portal" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <Menu.Trigger data-slot="dropdown-menu-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuContent(t0) {
  const $ = _c(18);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      className,
      align: t1,
      alignOffset: t2,
      side: t3,
      sideOffset: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  const align = t1 === undefined ? "start" : t1;
  const alignOffset = t2 === undefined ? 0 : t2;
  const side = t3 === undefined ? "bottom" : t3;
  const sideOffset = t4 === undefined ? 4 : t4;
  let t5;
  if ($[7] !== className) {
    t5 = cn("min-w-32 rounded-md border bg-popover p-1 text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden", "max-h-[var(--available-height)] origin-[var(--transform-origin)] overflow-x-hidden overflow-y-auto duration-100", "data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95", "data-closed:animate-out data-closed:overflow-hidden data-closed:fade-out-0 data-closed:zoom-out-95", "motion-reduce:animate-none motion-reduce:transition-none", "data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props || $[10] !== t5) {
    t6 = <Menu.Popup data-slot="dropdown-menu-content" className={t5} {...props} />;
    $[9] = props;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== align || $[13] !== alignOffset || $[14] !== side || $[15] !== sideOffset || $[16] !== t6) {
    t7 = <DropdownMenuPortal><Menu.Positioner align={align} alignOffset={alignOffset} side={side} sideOffset={sideOffset} className="pointer-events-auto isolate z-50 outline-none">{t6}</Menu.Positioner></DropdownMenuPortal>;
    $[12] = align;
    $[13] = alignOffset;
    $[14] = side;
    $[15] = sideOffset;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function DropdownMenuGroup(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <Menu.Group data-slot="dropdown-menu-group" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuItem(t0) {
  const $ = _c(18);
  let className;
  let inset;
  let onClick;
  let onSelect;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      variant: t1,
      onSelect,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = inset;
    $[3] = onClick;
    $[4] = onSelect;
    $[5] = props;
    $[6] = t1;
  } else {
    className = $[1];
    inset = $[2];
    onClick = $[3];
    onSelect = $[4];
    props = $[5];
    t1 = $[6];
  }
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[7] !== className) {
    t2 = cn("group/dropdown-menu-item relative flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground", "data-[inset]:pl-8", "data-disabled:pointer-events-none data-disabled:opacity-50", "data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:*:[svg]:text-destructive", "not-data-[variant=destructive]:focus:**:text-accent-foreground", className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== onClick || $[10] !== onSelect) {
    t3 = event => {
      onClick?.(event);
      onSelect?.(event);
    };
    $[9] = onClick;
    $[10] = onSelect;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== inset || $[13] !== props || $[14] !== t2 || $[15] !== t3 || $[16] !== variant) {
    t4 = <Menu.Item data-slot="dropdown-menu-item" data-inset={inset} data-variant={variant} className={t2} onClick={t3} {...props} />;
    $[12] = inset;
    $[13] = props;
    $[14] = t2;
    $[15] = t3;
    $[16] = variant;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
function DropdownMenuCheckboxItem(t0) {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("relative flex w-full cursor-pointer items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none", "focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="pointer-events-none absolute right-2 flex size-3.5 items-center justify-center" data-slot="dropdown-menu-checkbox-item-indicator"><Menu.CheckboxItemIndicator><IconCheck className="size-4" aria-hidden="true" /></Menu.CheckboxItemIndicator></span>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== t1) {
    t3 = <Menu.CheckboxItem data-slot="dropdown-menu-checkbox-item" className={t1} {...props}>{t2}{children}</Menu.CheckboxItem>;
    $[7] = children;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function DropdownMenuRadioGroup(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <Menu.RadioGroup data-slot="dropdown-menu-radio-group" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuRadioItem(t0) {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("relative flex w-full cursor-pointer items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none", "focus:bg-accent focus:text-accent-foreground focus:**:text-accent-foreground", "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50", "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="pointer-events-none absolute right-2 flex size-3.5 items-center justify-center" data-slot="dropdown-menu-radio-item-indicator"><Menu.RadioItemIndicator><IconCheck className="size-4" aria-hidden="true" /></Menu.RadioItemIndicator></span>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== t1) {
    t3 = <Menu.RadioItem data-slot="dropdown-menu-radio-item" className={t1} {...props}>{t2}{children}</Menu.RadioItem>;
    $[7] = children;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function DropdownMenuLabel(t0) {
  const $ = _c(10);
  let className;
  let inset;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = inset;
    $[3] = props;
  } else {
    className = $[1];
    inset = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("px-2 py-1.5 text-xs font-medium text-muted-foreground data-[inset]:pl-8", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== inset || $[7] !== props || $[8] !== t1) {
    t2 = <Menu.GroupLabel data-slot="dropdown-menu-label" data-inset={inset} className={t1} {...props} />;
    $[6] = inset;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function DropdownMenuSeparator(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("-mx-1 my-1 h-px bg-border", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <Menu.Separator data-slot="dropdown-menu-separator" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DropdownMenuShortcut(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("ml-auto text-xs tracking-widest text-muted-foreground group-focus/dropdown-menu-item:text-accent-foreground", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <span data-slot="dropdown-menu-shortcut" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DropdownMenuSub(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <Menu.SubmenuRoot data-slot="dropdown-menu-sub" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function DropdownMenuSubTrigger(t0) {
  const $ = _c(13);
  let children;
  let className;
  let inset;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = inset;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    inset = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[inset]:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", "data-open:bg-accent data-open:text-accent-foreground", "data-popup-open:bg-accent data-popup-open:text-accent-foreground", "not-data-[variant=destructive]:focus:**:text-accent-foreground", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconChevronRight className="ml-auto" aria-hidden="true" />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== inset || $[10] !== props || $[11] !== t1) {
    t3 = <Menu.SubmenuTrigger data-slot="dropdown-menu-sub-trigger" data-inset={inset} className={t1} {...props}>{children}{t2}</Menu.SubmenuTrigger>;
    $[8] = children;
    $[9] = inset;
    $[10] = props;
    $[11] = t1;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
function DropdownMenuSubContent(t0) {
  const $ = _c(16);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      className,
      align: t1,
      alignOffset: t2,
      side: t3,
      sideOffset: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  const align = t1 === undefined ? "start" : t1;
  const alignOffset = t2 === undefined ? -3 : t2;
  const side = t3 === undefined ? "right" : t3;
  const sideOffset = t4 === undefined ? 0 : t4;
  let t5;
  if ($[7] !== className) {
    t5 = cn("w-auto min-w-24 rounded-md shadow-lg", className);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== align || $[10] !== alignOffset || $[11] !== props || $[12] !== side || $[13] !== sideOffset || $[14] !== t5) {
    t6 = <DropdownMenuContent data-slot="dropdown-menu-sub-content" className={t5} align={align} alignOffset={alignOffset} side={side} sideOffset={sideOffset} {...props} />;
    $[9] = align;
    $[10] = alignOffset;
    $[11] = props;
    $[12] = side;
    $[13] = sideOffset;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
export { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger };